module.exports = __webpack_public_path__ + "static/communications-banner-950af460e6e6f214c953bb741ee3f1d3.png";